import React from "react";

const OurMission = () => (
  <section className="ls ms bio-parallax s-py-60 c-gutter-15">
    <div className="container-fluid">
      <div className="row">
        <div className="col-12 text-center">
          <h3 className="special-heading text-center underline">Our Mission</h3>
          <div className="divider-40"></div>
          <div className="author-bio-shortcode">
            <div className="bio-text">
              Our mission is to help foreigners by equipping them with the right
              knowledge they need to actualize their dream of studying, working
              & ultimately living in the US.
            </div>
          </div>
          <div className="divider-40 hidden-above-md"></div>
        </div>
      </div>
    </div>
  </section>
);

export default OurMission;
